<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-09-08 15:52:36
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2026-08-10 16:48:01
 * @FilePath: \vue-app-console\src\views\DataQuery\PartDistribution.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box">
            <a-select 
                v-if="userInfo.tenant_id == 1"
                class="query_field"
                v-model:value="searchForm.tenant_id"
                :placeholder="t('account.tenant')"
                :options="tenantOptions"
                @change="handleInputChange('tenant_id')"
            ></a-select>
            <a-input 
                class="query_field" 
                v-model:value="searchForm.frame_number" 
                allowClear
                :placeholder="t('partDistribution.frameNumber')"
                @change="handleInputChange('frame_number')"
            />
            <a-input 
                class="query_field" 
                v-model:value="searchForm.part_no" 
                allowClear
                :placeholder="t('partDistribution.partNumber')"
                @change="handleInputChange('part_no')"
            />
            <a-input 
                class="query_field" 
                v-model:value="searchForm.software_version" 
                allowClear
                :placeholder="t('partDistribution.softwareVersion')"
                @change="handleInputChange('software_version')"
            />
            <a-input 
                class="query_field" 
                v-model:value="searchForm.hardware_version" 
                allowClear
                :placeholder="t('partDistribution.hardwareVersion')"
                @change="handleInputChange('hardware_version')"
            />
            <a-button class="download_btn" type="primary" size="small" :loading="exportLoading" @click="downloadPartsData">
                <img src="@/assets/image/export.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('partDistribution.downloadData') }}
            </a-button>
        </div>

        <Table
            class="table"
            :table="table"
            @handleChangePagination="handleChangePagination"
        ></Table>
    </div>
    
</template>

<script setup>
    import { ref, reactive, onMounted } from 'vue';
    import { useI18n } from 'vue-i18n';
    import Header from '@/layouts/component/Header.vue';
    import Table from '@/components/Table.vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { PartDistributionApi } from '@/api/PartDistributionApi.js';
    import { exportFile } from '@/utils/global';
    import { message, Modal } from 'ant-design-vue';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';

    const { t } = useI18n()

    const headerData = ref({
        menu:'menu.PartDistribution',
        menu_desc:'menu.subPartDistribution',
        week: getWeek().week,
        current_time:getWeek().currentDate,
    })

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))

    const searchForm = reactive({
        tenant_id: userInfo.value?.tenant_id == 1 ? null : (userInfo.value?.tenant_id || ''),
        frame_number: '',
        part_no: '',
        software_version: '',
        hardware_version: '',
    })

    const exportLoading = ref(false)
    const tenantOptions = ref([])


    const table = ref({
        data: [],
        columns: [
            {
                title: t('partDistribution.frameNumber'),
                dataIndex: 'frame_number',
                key: 'frame_number',
                width:180,
                resizable: true,
                customRender: ({ text }) => (text == undefined || text === '' ? '-' : text),
            },
            {
                title: t('partDistribution.partNumber'),
                dataIndex: 'part_no',
                key: 'part_no',
                width:160,
                resizable: true,
                customRender: ({ text }) => (text == undefined || text === '' ? '-' : text),
            },
            {
                title: t('partDistribution.partName'),
                dataIndex: 'part_name',
                key: 'part_name',
                width:160,
                resizable: true,
                customRender: ({ text }) => (text == undefined || text === '' ? '-' : text),
            },
            {
                title: t('partDistribution.tripleId'),
                dataIndex: 'triple_id',
                key: 'triple_id',
                width:200,
                resizable: true,
                customRender: ({ text }) => (text == undefined || text === '' ? '-' : text),
            },
            {
                title: t('partDistribution.softwareVersion'),
                dataIndex: 'software_version',
                key: 'software_version',
                width:160,
                resizable: true,
                customRender: ({ text }) => (text == undefined || text === '' ? '-' : text),
            },
            {
                title: t('partDistribution.hardwareVersion'),
                dataIndex: 'hardware_version',
                key: 'hardware_version',
                width:160,
                resizable: true,
                customRender: ({ text }) => (text == undefined || text === '' ? '-' : text),
            },
            {
                title: t('account.tenant'),
                dataIndex: 'tenant_name',
                key: 'tenant_name',
                width:140,
                resizable: true,
                customRender: ({ text }) => (text == undefined || text === '' ? '-' : text),
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                y: 550,
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                showSizeChanger:true,
                pageSizeOptions:['10','20','50'],
                total:0,
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        }
    })

    const handleChangePagination =  (config)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const handleInputChange = ()=>{
        table.value.configs.pagination.current = 1
        getList()
    }

    const getList = async ()=>{
        try{
            let param = {
                sys_org: (userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id),
                frame_number: searchForm.frame_number.trim(),
                part_no: searchForm.part_no.trim(),
                software_version: searchForm.software_version.trim(),
                hardware_version: searchForm.hardware_version.trim(),
            }
            let page_num = table.value.configs.pagination.current
            let page_size = table.value.configs.pagination.pageSize

            table.value.configs.loading = true
            let res = await PartDistributionApi.getInstance().getPartsDistribution(param, page_num, page_size)
            if(!(res && res.code === 0)) throw new Error(res?.msg || res?.message || t('base.error'))

            let part_name_transfer = {
                'METER': 'Display',
                'MCU1': 'Drive Unit PCU',
                'MCU2': 'Drive Unit ECU',
                'BMS': 'Battery',
                '中控':'Drive unit ECU',
                '仪表':'Display', 
                '换挡设备':'Remote', 
                '控制器':'Controller', 
                '电控':'Drive unit PCU',
                '电池设备':'Battery',
                '蓝牙':'Bluetooth', 
                '钥匙':'Key',
            }
            // 映射部件名称
            res.data.records.forEach(item=>{item.part_name = part_name_transfer[item.part_name] || item.part_name || '-'})

            // 租户映射
            const optionsMap = (tenantOptions.value || []).reduce((acc, cur)=>{ if(cur.value !== null && cur.value !== undefined){ acc[cur.value] = cur.label }; return acc }, {})
            const fallbackTenantMap = { 0: 'hepha', 1: 'gobao', 6: 'corest' }
            const list = res.data?.records || []
            table.value.data = list.map((item, idx)=>({ 
                id: item.id ?? `${item.frame_number || 'row'}_${idx}`, 
                ...item,
                tenant_name: optionsMap[item.sys_org ?? item.tenant_id] || fallbackTenantMap[item.sys_org ?? item.tenant_id] || '-',
            }))
            table.value.configs.pagination.total = res.data?.total || list.length || 0
        }catch(err){
            message.error(err.message || t('base.error'))
        }finally{
            table.value.configs.loading = false
        }
    }

    const downloadPartsData = async ()=>{
        const buildParam = ()=>({
            sys_org: (userInfo.value?.tenant_id == 1 ? searchForm.tenant_id : userInfo.value?.tenant_id),
            frame_number: searchForm.frame_number || '',
            part_no: searchForm.part_no || '',
            software_version: searchForm.software_version || '',
            hardware_version: searchForm.hardware_version || '',
        })
        try{
            exportLoading.value = true
            let res = await PartDistributionApi.getInstance().downLoadPartsDistribution(buildParam())
            if(res.status == 200){
                exportFile(res.data, `${t('partDistribution.downloadData')}.csv`)
                message.success(t('base.downloadSucceeded'))
            }else{
                throw new Error(res?.msg || t('base.downloadFailed'))
            }
        }catch(err){
            Modal.error({ title: t('base.tip'), content: err.message || t('base.error'), okText: t('base.ok') })
        }finally{
            exportLoading.value = false
        }
    }

    const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res?.code === 0){
            tenantOptions.value = (res.data || []).map(item=>({ label: item.tenant_name, value: item.tenant_id }))
            if(userInfo.value?.tenant_id == 1){
                tenantOptions.value.unshift({ label: t('access.allTenant'), value: null })
            }
        } else {
            message.error(res.msg || t('base.getDataFail'));
        }
    }

    onMounted(()=>{
        getTenantList()
        getList()
    })
</script>

<style lang="scss" scoped>
::v-deep .ant-table-wrapper .ant-table-thead>tr>th,
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td,
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

.table{
    margin-top: 20px;
}

.query_box{
    margin-top: 30px;
    margin-bottom: 10px;
    // display: flex;
    // align-items: center;

    .query_field{
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 5px;
        width: 200px;
        vertical-align: middle;
    }
}

.download_box{
    margin-bottom: 10px;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

// 当sub不为空时
// ::v-deep .page_header .week{
//     margin-top: -70px;
// }
// ::v-deep .page_header .admin_email{
//     margin-top: -60px;
// }

::v-deep .query_box .ant-input{
    height: 30px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
::v-deep .query_box .ant-input-affix-wrapper{
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    top: 1px;
    border-radius: 4px;
}
::v-deep .query_box .ant-input-affix-wrapper > input.ant-input{
    height: 30px;
    line-height: 30px;
}
</style>